// extracted by mini-css-extract-plugin
export default {"window":"LogoBackdrop_window__21yRa","window-hidden":"LogoBackdrop_window-hidden__NTqNm","window-outer":"LogoBackdrop_window-outer__Uc9pq","logo":"LogoBackdrop_logo__d6vqS"};